<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="title-wrapper">
    <div class="m-t-30 img-header">
      <img src="/assets/img/template/04-neurologie/neuro-header.png" />
    </div>
		<h1>
			Neurologie
		</h1>
		<div class="title-description">
      <ul class="bullet-neurologie">
        <li>Morbus Fabry kann Auswirkungen auf das periphere und das zentrale Nervensystem haben.<sup class="info-section-text-ref">1–10</sup></li>
        <li><a href="fachgebiete/neurologie#section-1" class="color-neurologie"><strong>Neuropathische Schmerzen</strong></a> sind häufig frühe Symptome.<sup class="info-section-text-ref">1</sup></li>
        <li><a href="fachgebiete/neurologie#section-2" class="color-neurologie"><strong>Zerebrovaskuläre Symptome</strong></a></li>
        <li>Im Erwachsenenalter: <a href="fachgebiete/neurologie#section-2" class="color-neurologie"><strong>Schlaganfall</strong></a>, TIA, Schwindel, Kopfschmerzen<sup class="info-section-text-ref">1</sup> - Häufigkeit: Männer 64 %, Frauen 72 %<sup class="info-section-text-ref">10</sup></li>
      </ul>
		</div>
	</div>

  <div class="info-section m-b-50">
    <div class="wrapper-half-title-center">
      <div class="separator m-t-0 neurologie"></div>
      <div class="info-section-title">
        Wann sollten Neurologen auf Morbus Fabry testen?
      </div>
    </div>
    <div class="wrapper-title-center">
      <ul class="bullet-neurologie text-center">
        <li>Bei <a href="fachgebiete/neurologie#section-3" class="color-neurologie"><strong>Schlaganfall</strong></a>/TIA im jungen Lebensalter (18–55 Jahre)<sup class="info-section-text-ref">3</sup></li>
        <li>Bei ungeklärten <a href="fachgebiete/neurologie#section-4" class="color-neurologie"><strong>neuropathischen Schmerzen</strong></a><sup class="info-section-text-ref">11</sup></li>
        <li>Bei Anzeichen weiterer <a href="morbus-fabry#section-3a" class="color-neurologie"><strong>Organbeteiligung</strong></a> (z.B. Herz, Niere, Auge, Gastrointestinaltrakt)<sup class="info-section-text-ref">11</sup></li>
        <li>Bei relevanter <a href="morbus-fabry#section-5" class="color-neurologie"><strong>Familienanamnese</strong></a><sup class="info-section-text-ref">11</sup></li>
        <li>Bei Verdacht auf Multiple Sklerose ohne Nachweis oligoklonaler Banden<sup class="info-section-text-ref">11</sup></li>
      </ul>
    </div>
  </div>

  <div class="info-section fullwidth info-ribbon with-video-float color-white bgcolor-neurologie">
    <div class="ribbon-left"><img src="/assets/img/template/04-neurologie/dreieck-1.png"></div>
    <div class="info-section-title">
			Wann sollte in der Neurologie an  Morbus Fabry gedacht werden?
		</div>
    <p class="text-center">
      Dies erläutert PD Dr. Tobias Böttcher, Greifswald, im Neurologie-Expertenvideo.
		</p>
    <div class="video-float">
      <iframe src="https://www.youtube.com/embed/e2ftoowxRtc"  class="neurologie" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
	</div>

  <!--  <app-login zone="education">-->
    <app-login zone="2000000017233"> <!-- Development -->
  <!--  <app-login zone="2000000017236"> <!-- Takeda Server -->
  <!--    <app-login zone="2000000017236"> <!-- Production -->
  </app-login>

<app-footer>
</app-footer>

</div>
